"use strict";
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _regeneratorRuntime = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var child_process_1 = require("child_process");

var fs = require("fs");

var gcpMetadata = require("gcp-metadata");

var os = require("os");

var path = require("path");

var crypto_1 = require("../crypto/crypto");

var isbrowser_1 = require("../isbrowser");

var messages = require("../messages");

var transporters_1 = require("../transporters");

var computeclient_1 = require("./computeclient");

var envDetect_1 = require("./envDetect");

var jwtclient_1 = require("./jwtclient");

var refreshclient_1 = require("./refreshclient");

exports.CLOUD_SDK_CLIENT_ID = '764086051850-6qr4p6gpi6hn506pt8ejuq83di341hur.apps.googleusercontent.com';

var GoogleAuth =
/*#__PURE__*/
function () {
  function GoogleAuth(opts) {
    _classCallCheck(this, GoogleAuth);

    /**
     * Caches a value indicating whether the auth layer is running on Google
     * Compute Engine.
     * @private
     */
    this.checkIsGCE = undefined; // To save the contents of the JSON credential file

    this.jsonContent = null;
    this.cachedCredential = null;
    opts = opts || {};
    this._cachedProjectId = opts.projectId || null;
    this.keyFilename = opts.keyFilename || opts.keyFile;
    this.scopes = opts.scopes;
    this.jsonContent = opts.credentials || null;
    this.clientOptions = opts.clientOptions;
  } // Note:  this properly is only public to satisify unit tests.
  // https://github.com/Microsoft/TypeScript/issues/5228


  _createClass(GoogleAuth, [{
    key: "getDefaultProjectId",
    value: function getDefaultProjectId(callback) {
      messages.warn(messages.DEFAULT_PROJECT_ID_DEPRECATED);

      if (callback) {
        this.getProjectIdAsync().then(function (r) {
          return callback(null, r);
        }, callback);
      } else {
        return this.getProjectIdAsync();
      }
    }
  }, {
    key: "getProjectId",
    value: function getProjectId(callback) {
      if (callback) {
        this.getProjectIdAsync().then(function (r) {
          return callback(null, r);
        }, callback);
      } else {
        return this.getProjectIdAsync();
      }
    }
  }, {
    key: "getProjectIdAsync",
    value: function getProjectIdAsync() {
      var _this = this;

      if (this._cachedProjectId) {
        return Promise.resolve(this._cachedProjectId);
      } // In implicit case, supports three environments. In order of precedence,
      // the implicit environments are:
      // - GCLOUD_PROJECT or GOOGLE_CLOUD_PROJECT environment variable
      // - GOOGLE_APPLICATION_CREDENTIALS JSON file
      // - Cloud SDK: `gcloud config config-helper --format json`
      // - GCE project ID from metadata server)


      if (!this._getDefaultProjectIdPromise) {
        this._getDefaultProjectIdPromise = new Promise(
        /*#__PURE__*/
        function () {
          var _ref = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee(resolve, reject) {
            var projectId;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.t2 = _this.getProductionProjectId();

                    if (_context.t2) {
                      _context.next = 6;
                      break;
                    }

                    _context.next = 5;
                    return _this.getFileProjectId();

                  case 5:
                    _context.t2 = _context.sent;

                  case 6:
                    _context.t1 = _context.t2;

                    if (_context.t1) {
                      _context.next = 11;
                      break;
                    }

                    _context.next = 10;
                    return _this.getDefaultServiceProjectId();

                  case 10:
                    _context.t1 = _context.sent;

                  case 11:
                    _context.t0 = _context.t1;

                    if (_context.t0) {
                      _context.next = 16;
                      break;
                    }

                    _context.next = 15;
                    return _this.getGCEProjectId();

                  case 15:
                    _context.t0 = _context.sent;

                  case 16:
                    projectId = _context.t0;
                    _this._cachedProjectId = projectId;

                    if (projectId) {
                      _context.next = 20;
                      break;
                    }

                    throw new Error('Unable to detect a Project Id in the current environment. \n' + 'To learn more about authentication and Google APIs, visit: \n' + 'https://cloud.google.com/docs/authentication/getting-started');

                  case 20:
                    resolve(projectId);
                    _context.next = 26;
                    break;

                  case 23:
                    _context.prev = 23;
                    _context.t3 = _context["catch"](0);
                    reject(_context.t3);

                  case 26:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 23]]);
          }));

          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
      }

      return this._getDefaultProjectIdPromise;
    }
  }, {
    key: "getApplicationDefault",
    value: function getApplicationDefault() {
      var optionsOrCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var options;

      if (typeof optionsOrCallback === 'function') {
        callback = optionsOrCallback;
      } else {
        options = optionsOrCallback;
      }

      if (callback) {
        this.getApplicationDefaultAsync(options).then(function (r) {
          return callback(null, r.credential, r.projectId);
        }, callback);
      } else {
        return this.getApplicationDefaultAsync(options);
      }
    }
  }, {
    key: "getApplicationDefaultAsync",
    value: function () {
      var _getApplicationDefaultAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var options,
            credential,
            projectId,
            isGCE,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};

                if (!this.cachedCredential) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = this.cachedCredential;
                _context2.next = 5;
                return this.getProjectIdAsync();

              case 5:
                _context2.t1 = _context2.sent;
                return _context2.abrupt("return", {
                  credential: _context2.t0,
                  projectId: _context2.t1
                });

              case 7:
                _context2.next = 9;
                return this._tryGetApplicationCredentialsFromEnvironmentVariable(options);

              case 9:
                credential = _context2.sent;

                if (!credential) {
                  _context2.next = 17;
                  break;
                }

                if (credential instanceof jwtclient_1.JWT) {
                  credential.scopes = this.scopes;
                }

                this.cachedCredential = credential;
                _context2.next = 15;
                return this.getProjectId();

              case 15:
                projectId = _context2.sent;
                return _context2.abrupt("return", {
                  credential: credential,
                  projectId: projectId
                });

              case 17:
                _context2.next = 19;
                return this._tryGetApplicationCredentialsFromWellKnownFile(options);

              case 19:
                credential = _context2.sent;

                if (!credential) {
                  _context2.next = 27;
                  break;
                }

                if (credential instanceof jwtclient_1.JWT) {
                  credential.scopes = this.scopes;
                }

                this.cachedCredential = credential;
                _context2.next = 25;
                return this.getProjectId();

              case 25:
                projectId = _context2.sent;
                return _context2.abrupt("return", {
                  credential: credential,
                  projectId: projectId
                });

              case 27:
                _context2.prev = 27;
                _context2.next = 30;
                return this._checkIsGCE();

              case 30:
                isGCE = _context2.sent;
                _context2.next = 37;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t2 = _context2["catch"](27);
                _context2.t2.message = "Unexpected error determining execution environment: ".concat(_context2.t2.message);
                throw _context2.t2;

              case 37:
                if (isGCE) {
                  _context2.next = 39;
                  break;
                }

                throw new Error('Could not load the default credentials. Browse to https://cloud.google.com/docs/authentication/getting-started for more information.');

              case 39:
                // For GCE, just return a default ComputeClient. It will take care of
                // the rest.
                options.scopes = this.scopes;
                this.cachedCredential = new computeclient_1.Compute(options);
                _context2.next = 43;
                return this.getProjectId();

              case 43:
                projectId = _context2.sent;
                return _context2.abrupt("return", {
                  projectId: projectId,
                  credential: this.cachedCredential
                });

              case 45:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[27, 33]]);
      }));

      function getApplicationDefaultAsync() {
        return _getApplicationDefaultAsync.apply(this, arguments);
      }

      return getApplicationDefaultAsync;
    }()
    /**
     * Determines whether the auth layer is running on Google Compute Engine.
     * @returns A promise that resolves with the boolean.
     * @api private
     */

  }, {
    key: "_checkIsGCE",
    value: function () {
      var _checkIsGCE2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.checkIsGCE === undefined)) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 3;
                return gcpMetadata.isAvailable();

              case 3:
                this.checkIsGCE = _context3.sent;

              case 4:
                return _context3.abrupt("return", this.checkIsGCE);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _checkIsGCE() {
        return _checkIsGCE2.apply(this, arguments);
      }

      return _checkIsGCE;
    }()
    /**
     * Attempts to load default credentials from the environment variable path..
     * @returns Promise that resolves with the OAuth2Client or null.
     * @api private
     */

  }, {
    key: "_tryGetApplicationCredentialsFromEnvironmentVariable",
    value: function () {
      var _tryGetApplicationCredentialsFromEnvironmentVariable2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(options) {
        var credentialsPath;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                credentialsPath = process.env['GOOGLE_APPLICATION_CREDENTIALS'] || process.env['google_application_credentials'];

                if (!(!credentialsPath || credentialsPath.length === 0)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", null);

              case 3:
                _context4.prev = 3;
                return _context4.abrupt("return", this._getApplicationCredentialsFromFilePath(credentialsPath, options));

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](3);
                _context4.t0.message = "Unable to read the credential file specified by the GOOGLE_APPLICATION_CREDENTIALS environment variable: ".concat(_context4.t0.message);
                throw _context4.t0;

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 7]]);
      }));

      function _tryGetApplicationCredentialsFromEnvironmentVariable(_x3) {
        return _tryGetApplicationCredentialsFromEnvironmentVariable2.apply(this, arguments);
      }

      return _tryGetApplicationCredentialsFromEnvironmentVariable;
    }()
    /**
     * Attempts to load default credentials from a well-known file location
     * @return Promise that resolves with the OAuth2Client or null.
     * @api private
     */

  }, {
    key: "_tryGetApplicationCredentialsFromWellKnownFile",
    value: function () {
      var _tryGetApplicationCredentialsFromWellKnownFile2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(options) {
        var location, home, client;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // First, figure out the location of the file, depending upon the OS type.
                location = null;

                if (this._isWindows()) {
                  // Windows
                  location = process.env['APPDATA'];
                } else {
                  // Linux or Mac
                  home = process.env['HOME'];

                  if (home) {
                    location = path.join(home, '.config');
                  }
                } // If we found the root path, expand it.


                if (location) {
                  location = path.join(location, 'gcloud', 'application_default_credentials.json');

                  if (!fs.existsSync(location)) {
                    location = null;
                  }
                } // The file does not exist.


                if (location) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", null);

              case 5:
                _context5.next = 7;
                return this._getApplicationCredentialsFromFilePath(location, options);

              case 7:
                client = _context5.sent;
                this.warnOnProblematicCredentials(client);
                return _context5.abrupt("return", client);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _tryGetApplicationCredentialsFromWellKnownFile(_x4) {
        return _tryGetApplicationCredentialsFromWellKnownFile2.apply(this, arguments);
      }

      return _tryGetApplicationCredentialsFromWellKnownFile;
    }()
    /**
     * Attempts to load default credentials from a file at the given path..
     * @param filePath The path to the file to read.
     * @returns Promise that resolves with the OAuth2Client
     * @api private
     */

  }, {
    key: "_getApplicationCredentialsFromFilePath",
    value: function () {
      var _getApplicationCredentialsFromFilePath2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(filePath) {
        var options,
            readStream,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};

                if (!(!filePath || filePath.length === 0)) {
                  _context6.next = 3;
                  break;
                }

                throw new Error('The file path is invalid.');

              case 3:
                _context6.prev = 3;
                // Resolve path to actual file in case of symlink. Expect a thrown error
                // if not resolvable.
                filePath = fs.realpathSync(filePath);

                if (fs.lstatSync(filePath).isFile()) {
                  _context6.next = 7;
                  break;
                }

                throw new Error();

              case 7:
                _context6.next = 13;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](3);
                _context6.t0.message = "The file at ".concat(filePath, " does not exist, or it is not a file. ").concat(_context6.t0.message);
                throw _context6.t0;

              case 13:
                // Now open a read stream on the file, and parse it.
                readStream = fs.createReadStream(filePath);
                return _context6.abrupt("return", this.fromStream(readStream, options));

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3, 9]]);
      }));

      function _getApplicationCredentialsFromFilePath(_x5) {
        return _getApplicationCredentialsFromFilePath2.apply(this, arguments);
      }

      return _getApplicationCredentialsFromFilePath;
    }()
    /**
     * Credentials from the Cloud SDK that are associated with Cloud SDK's project
     * are problematic because they may not have APIs enabled and have limited
     * quota. If this is the case, warn about it.
     */

  }, {
    key: "warnOnProblematicCredentials",
    value: function warnOnProblematicCredentials(client) {
      if (client.email === exports.CLOUD_SDK_CLIENT_ID) {
        messages.warn(messages.PROBLEMATIC_CREDENTIALS_WARNING);
      }
    }
    /**
     * Create a credentials instance using the given input options.
     * @param json The input object.
     * @param options The JWT or UserRefresh options for the client
     * @returns JWT or UserRefresh Client with data
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json, options) {
      var client;

      if (!json) {
        throw new Error('Must pass in a JSON object containing the Google auth settings.');
      }

      this.jsonContent = json;
      options = options || {};

      if (json.type === 'authorized_user') {
        client = new refreshclient_1.UserRefreshClient(options);
      } else {
        options.scopes = this.scopes;
        client = new jwtclient_1.JWT(options);
      }

      client.fromJSON(json);
      return client;
    }
  }, {
    key: "fromStream",
    value: function fromStream(inputStream) {
      var optionsOrCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var options = {};

      if (typeof optionsOrCallback === 'function') {
        callback = optionsOrCallback;
      } else {
        options = optionsOrCallback;
      }

      if (callback) {
        this.fromStreamAsync(inputStream, options).then(function (r) {
          return callback(null, r);
        }, callback);
      } else {
        return this.fromStreamAsync(inputStream, options);
      }
    }
  }, {
    key: "fromStreamAsync",
    value: function fromStreamAsync(inputStream, options) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        if (!inputStream) {
          throw new Error('Must pass in a stream containing the Google auth settings.');
        }

        var s = '';
        inputStream.setEncoding('utf8').on('error', reject).on('data', function (chunk) {
          return s += chunk;
        }).on('end', function () {
          try {
            var data = JSON.parse(s);

            var r = _this2.fromJSON(data, options);

            return resolve(r);
          } catch (err) {
            return reject(err);
          }
        });
      });
    }
    /**
     * Create a credentials instance using the given API key string.
     * @param apiKey The API key string
     * @param options An optional options object.
     * @returns A JWT loaded from the key
     */

  }, {
    key: "fromAPIKey",
    value: function fromAPIKey(apiKey, options) {
      options = options || {};
      var client = new jwtclient_1.JWT(options);
      client.fromAPIKey(apiKey);
      return client;
    }
    /**
     * Determines whether the current operating system is Windows.
     * @api private
     */

  }, {
    key: "_isWindows",
    value: function _isWindows() {
      var sys = os.platform();

      if (sys && sys.length >= 3) {
        if (sys.substring(0, 3).toLowerCase() === 'win') {
          return true;
        }
      }

      return false;
    }
    /**
     * Run the Google Cloud SDK command that prints the default project ID
     */

  }, {
    key: "getDefaultServiceProjectId",
    value: function () {
      var _getDefaultServiceProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function (resolve) {
                  child_process_1.exec('gcloud config config-helper --format json', function (err, stdout, stderr) {
                    if (!err && stdout) {
                      try {
                        var projectId = JSON.parse(stdout).configuration.properties.core.project;
                        resolve(projectId);
                        return;
                      } catch (e) {// ignore errors
                      }
                    }

                    resolve(null);
                  });
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getDefaultServiceProjectId() {
        return _getDefaultServiceProjectId.apply(this, arguments);
      }

      return getDefaultServiceProjectId;
    }()
    /**
     * Loads the project id from environment variables.
     * @api private
     */

  }, {
    key: "getProductionProjectId",
    value: function getProductionProjectId() {
      return process.env['GCLOUD_PROJECT'] || process.env['GOOGLE_CLOUD_PROJECT'] || process.env['gcloud_project'] || process.env['google_cloud_project'];
    }
    /**
     * Loads the project id from the GOOGLE_APPLICATION_CREDENTIALS json file.
     * @api private
     */

  }, {
    key: "getFileProjectId",
    value: function () {
      var _getFileProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var creds, r;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.cachedCredential) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", this.cachedCredential.projectId);

              case 2:
                if (!this.keyFilename) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 5;
                return this.getClient();

              case 5:
                creds = _context8.sent;

                if (!(creds && creds.projectId)) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("return", creds.projectId);

              case 8:
                _context8.next = 10;
                return this._tryGetApplicationCredentialsFromEnvironmentVariable();

              case 10:
                r = _context8.sent;

                if (!r) {
                  _context8.next = 15;
                  break;
                }

                return _context8.abrupt("return", r.projectId);

              case 15:
                return _context8.abrupt("return", null);

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getFileProjectId() {
        return _getFileProjectId.apply(this, arguments);
      }

      return getFileProjectId;
    }()
    /**
     * Gets the Compute Engine project ID if it can be inferred.
     */

  }, {
    key: "getGCEProjectId",
    value: function () {
      var _getGCEProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var r;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return gcpMetadata.project('project-id');

              case 3:
                r = _context9.sent;
                return _context9.abrupt("return", r);

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", null);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 7]]);
      }));

      function getGCEProjectId() {
        return _getGCEProjectId.apply(this, arguments);
      }

      return getGCEProjectId;
    }()
  }, {
    key: "getCredentials",
    value: function getCredentials(callback) {
      if (callback) {
        this.getCredentialsAsync().then(function (r) {
          return callback(null, r);
        }, callback);
      } else {
        return this.getCredentialsAsync();
      }
    }
  }, {
    key: "getCredentialsAsync",
    value: function () {
      var _getCredentialsAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var credential, isGCE, data;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.getClient();

              case 2:
                if (!this.jsonContent) {
                  _context10.next = 5;
                  break;
                }

                credential = {
                  client_email: this.jsonContent.client_email,
                  private_key: this.jsonContent.private_key
                };
                return _context10.abrupt("return", credential);

              case 5:
                _context10.next = 7;
                return this._checkIsGCE();

              case 7:
                isGCE = _context10.sent;

                if (isGCE) {
                  _context10.next = 10;
                  break;
                }

                throw new Error('Unknown error.');

              case 10:
                _context10.next = 12;
                return gcpMetadata.instance({
                  property: 'service-accounts/',
                  params: {
                    recursive: 'true'
                  }
                });

              case 12:
                data = _context10.sent;

                if (!(!data || !data.default || !data.default.email)) {
                  _context10.next = 15;
                  break;
                }

                throw new Error('Failure from metadata server.');

              case 15:
                return _context10.abrupt("return", {
                  client_email: data.default.email
                });

              case 16:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getCredentialsAsync() {
        return _getCredentialsAsync.apply(this, arguments);
      }

      return getCredentialsAsync;
    }()
    /**
     * Automatically obtain a client based on the provided configuration.  If no
     * options were passed, use Application Default Credentials.
     */

  }, {
    key: "getClient",
    value: function () {
      var _getClient = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(options) {
        var filePath, stream;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (options) {
                  this.keyFilename = options.keyFilename || options.keyFile || this.keyFilename;
                  this.scopes = options.scopes || this.scopes;
                  this.jsonContent = options.credentials || this.jsonContent;
                  this.clientOptions = options.clientOptions;
                }

                if (this.cachedCredential) {
                  _context11.next = 18;
                  break;
                }

                if (!this.jsonContent) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 5;
                return this.fromJSON(this.jsonContent, this.clientOptions);

              case 5:
                this.cachedCredential = _context11.sent;
                _context11.next = 18;
                break;

              case 8:
                if (!this.keyFilename) {
                  _context11.next = 16;
                  break;
                }

                filePath = path.resolve(this.keyFilename);
                stream = fs.createReadStream(filePath);
                _context11.next = 13;
                return this.fromStreamAsync(stream, this.clientOptions);

              case 13:
                this.cachedCredential = _context11.sent;
                _context11.next = 18;
                break;

              case 16:
                _context11.next = 18;
                return this.getApplicationDefaultAsync(this.clientOptions);

              case 18:
                return _context11.abrupt("return", this.cachedCredential);

              case 19:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getClient(_x6) {
        return _getClient.apply(this, arguments);
      }

      return getClient;
    }()
    /**
     * Automatically obtain application default credentials, and return
     * an access token for making requests.
     */

  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var client;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.getClient();

              case 2:
                client = _context12.sent;
                _context12.next = 5;
                return client.getAccessToken();

              case 5:
                return _context12.abrupt("return", _context12.sent.token);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getAccessToken() {
        return _getAccessToken.apply(this, arguments);
      }

      return getAccessToken;
    }()
    /**
     * Obtain the HTTP headers that will provide authorization for a given
     * request.
     */

  }, {
    key: "getRequestHeaders",
    value: function () {
      var _getRequestHeaders = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(url) {
        var client;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.getClient();

              case 2:
                client = _context13.sent;
                return _context13.abrupt("return", client.getRequestHeaders(url));

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getRequestHeaders(_x7) {
        return _getRequestHeaders.apply(this, arguments);
      }

      return getRequestHeaders;
    }()
    /**
     * Obtain credentials for a request, then attach the appropriate headers to
     * the request options.
     * @param opts Axios or Request options on which to attach the headers
     */

  }, {
    key: "authorizeRequest",
    value: function () {
      var _authorizeRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(opts) {
        var url, client, headers;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                opts = opts || {};
                url = opts.url || opts.uri;
                _context14.next = 4;
                return this.getClient();

              case 4:
                client = _context14.sent;
                _context14.next = 7;
                return client.getRequestHeaders(url);

              case 7:
                headers = _context14.sent;
                opts.headers = Object.assign(opts.headers || {}, headers);
                return _context14.abrupt("return", opts);

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function authorizeRequest(_x8) {
        return _authorizeRequest.apply(this, arguments);
      }

      return authorizeRequest;
    }()
    /**
     * Automatically obtain application default credentials, and make an
     * HTTP request using the given options.
     * @param opts Axios request options for the HTTP request.
     */
    // tslint:disable-next-line no-any

  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(opts) {
        var client;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.getClient();

              case 2:
                client = _context15.sent;
                return _context15.abrupt("return", client.request(opts));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function request(_x9) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
    /**
     * Determine the compute environment in which the code is running.
     */

  }, {
    key: "getEnv",
    value: function getEnv() {
      return envDetect_1.getEnv();
    }
    /**
     * Sign the given data with the current private key, or go out
     * to the IAM API to sign it.
     * @param data The data to be signed.
     */

  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(data) {
        var client, crypto, _sign2, projectId, creds, id, res;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.getClient();

              case 2:
                client = _context16.sent;
                crypto = crypto_1.createCrypto();

                if (!(client instanceof jwtclient_1.JWT && client.key && !isbrowser_1.isBrowser())) {
                  _context16.next = 8;
                  break;
                }

                _sign2 = crypto.createSign('RSA-SHA256');

                _sign2.update(data);

                return _context16.abrupt("return", _sign2.sign(client.key, 'base64'));

              case 8:
                _context16.next = 10;
                return this.getProjectId();

              case 10:
                projectId = _context16.sent;

                if (projectId) {
                  _context16.next = 13;
                  break;
                }

                throw new Error('Cannot sign data without a project ID.');

              case 13:
                _context16.next = 15;
                return this.getCredentials();

              case 15:
                creds = _context16.sent;

                if (creds.client_email) {
                  _context16.next = 18;
                  break;
                }

                throw new Error('Cannot sign data without `client_email`.');

              case 18:
                id = "projects/".concat(projectId, "/serviceAccounts/").concat(creds.client_email);
                _context16.next = 21;
                return this.request({
                  method: 'POST',
                  url: "https://iam.googleapis.com/v1/".concat(id, ":signBlob"),
                  data: {
                    bytesToSign: crypto.encodeBase64StringUtf8(data)
                  }
                });

              case 21:
                res = _context16.sent;
                return _context16.abrupt("return", res.data.signature);

              case 23:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function sign(_x10) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "isGCE",
    get: function get() {
      return this.checkIsGCE;
    }
  }]);

  return GoogleAuth;
}();
/**
 * Export DefaultTransporter as a static property of the class.
 */


GoogleAuth.DefaultTransporter = transporters_1.DefaultTransporter;
exports.GoogleAuth = GoogleAuth;